import { createContext, useContext } from "react";
import type { ReactNode } from "react";

interface AdminNavigationContextValue {
  isAdminLayout: boolean;
  activeSidebarLabels: string[];
  sharedHeaderDivider: boolean;
}

const defaultValue: AdminNavigationContextValue = {
  isAdminLayout: false,
  activeSidebarLabels: [],
  sharedHeaderDivider: false,
};

const AdminNavigationContext = createContext<AdminNavigationContextValue>(defaultValue);

interface AdminNavigationProviderProps {
  value: AdminNavigationContextValue;
  children: ReactNode;
}

export const AdminNavigationProvider = ({ value, children }: AdminNavigationProviderProps) => {
  return (
    <AdminNavigationContext.Provider value={value}>
      {children}
    </AdminNavigationContext.Provider>
  );
};

export const useAdminNavigation = () => useContext(AdminNavigationContext);
